

import ErrorToast from 'components/atoms/toasts/ErrorToast'
import SuccessToast from 'components/atoms/toasts/SuccessToast'
import ActionButtonToast from 'components/atoms/toasts/ActionButtonToast'
import SelectedRequestToast from 'components/atoms/toasts/SelectedRequestToast'

import initialState from 'reducers/initialState'
import { LOCATION_CHANGE } from 'constants/actions'

// Actions
export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'
export const ERROR_TOAST = ['ERROR_TOAST', ErrorToast]
export const SUCCESS_TOAST = ['SUCCESS_TOAST', SuccessToast]
export const ACTION_BUTTON_TOAST = ['ACTION_BUTTON_TOAST', ActionButtonToast]
export const SELECTED_REQUESTS_TOAST = ['SELECTED_REQUESTS_TOAST', SelectedRequestToast]

// Reducer
export default function reducer(state = initialState.toast, action) {
  // Show toast for all error messages, TODO: check disabling for launch
  if (action.type.indexOf('_ERROR') > -1 && action.type.indexOf('@@') === -1) {
    return {
      ...state,
      open: true,
      componentName: ERROR_TOAST[0],
      data: action.error
    }
  }

  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...state,
        open: true,
        componentName: action.componentName,
        data: action.data,
      }
    case HIDE_TOAST:
      return {
        ...state,
        open: false,
      }
    case LOCATION_CHANGE:
      return {
        ...state,
        open: false
      }
    default:
      return state
  }
}

// Action Creators
export function showToast(toast, data) {
  return {
    type: SHOW_TOAST,
    componentName: toast[0],
    data,
  }
}

export function hideToast() {
  return {
    type: HIDE_TOAST,
  }
}



// WEBPACK FOOTER //
// ./src/modules/toast.js